module.exports = __webpack_public_path__ + "static/media/sq-min.0413f52d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/sq-min.svg
// module id = 687
// module chunks = 0